import { FaStar, FaUserCircle } from "react-icons/fa";

const testimonials = [
  {
    id: 1,
    name: "David Okafor",
    role: "SOC Analyst at Fintech Co.",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80",
    review:
      "The practical labs at Cephas ICT Hub were the game changer. I transitioned from general IT to a SOC role within 3 months of completing the course.",
  },
  {
    id: 2,
    name: "Fatima Yusuf",
    role: "Network Security Lead",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80",
    review:
      "Highly recommended for anyone serious about cybersecurity. The mentors are experts and they provide real-world insights that you won't find in textbooks.",
  },
  {
    id: 3,
    name: "Samuel Thompson",
    role: "Security Consultant",
    image:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80",
    review:
      "From the basics of networking to advanced pentesting, the curriculum is incredibly well-structured. Cephas gave me the confidence to secure global networks.",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-[#F8FAFC] lg:py-24 py-8">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <h2 className="text-center text-2xl font-extrabold text-[#12105E] mb-16 md:text-4xl">
          What Our Students Say
        </h2>

        {/* Cards */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-3xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300 p-8 border-b-4 border-b-amber-800"
            >
              <div className="mb-4 flex items-center gap-1 text-orange-400">
                {[...Array(5)].map((_, index) => (
                  <FaStar
                    key={index}
                    className="text-lg"
                  />
                ))}
              </div>

              <div className=" py-6">
                <p className="italic text-[#191C1E] leading-8 text-[17px]">
                  "{item.review}"
                </p>
              </div>

              <div className="flex items-center gap-4 mb-8">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-12 h-12 rounded-full object-cover border-[3px] border-blue-600"
                />

                <div>
                  <h3 className="font-bold text-[#08213f]">{item.name}</h3>

                  <p className="text-[#191C1E] text-sm">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
